var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFriends(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 28.5C22.4558 28.5 28.5 22.4558 28.5 15C28.5 7.54416 22.4558 1.5 15 1.5C7.54416 1.5 1.5 7.54416 1.5 15C1.5 22.4558 7.54416 28.5 15 28.5ZM15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z",
    fill: "#008AAC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5806 14.1059C16.6569 13.6649 17.4193 12.5665 17.4193 11.2813C17.4193 9.99602 16.6569 8.89761 15.5806 8.45665C15.9062 8.32323 16.2606 8.25 16.6313 8.25C18.2272 8.25 19.5208 9.60714 19.5208 11.2813C19.5208 12.9554 18.2272 14.3125 16.6313 14.3125C16.2606 14.3125 15.9062 14.2393 15.5806 14.1059Z",
    fill: "#008AAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7817 20.3749L22.9882 20.3749C22.9882 18.5684 21.7013 17.0109 19.9087 16.7875C19.7275 16.7649 19.5434 16.743 19.3577 16.7222C20.2547 17.6665 20.7817 18.9785 20.7817 20.3749Z",
    fill: "#008AAC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2112 11.2813C16.2112 12.9554 14.9175 14.3125 13.3216 14.3125C11.7258 14.3125 10.4321 12.9554 10.4321 11.2813C10.4321 9.60714 11.7258 8.25 13.3216 8.25C14.9175 8.25 16.2112 9.60714 16.2112 11.2813Z",
    fill: "#008AAC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9646 20.3749C6.9646 18.0658 8.55039 16.0298 10.839 15.7222C11.6944 15.6071 12.5692 15.5249 13.3215 15.5249C14.0739 15.5249 14.9487 15.6071 15.8041 15.7222C18.0927 16.0298 19.6785 18.0658 19.6785 20.3749H6.9646Z",
    fill: "#008AAC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriends);
export default __webpack_public_path__ + "static/media/friends.5fa8bc40e34d2c6f588b91e269a2927c.svg";
export { ForwardRef as ReactComponent };